import React, {Component} from 'react';
import '../css/ToolTip.css';

class ToolTip extends Component {
	constructor(props) {
		super(props);

		this.state = {
			display: false
		}

		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	}

	componentWillMount() {
		document.addEventListener('click', this.handleClick, false);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick, false);
	}

	handleClick(event) {
		event.stopPropagation();

		if (this.node.contains(event.target)) {
			let newDisplay = !this.state.display;

			setTimeout(() => {
				this.setState({display: newDisplay});
			}, 100);
			return;
		}

		this.handleOutsideClick();
	}

	handleOutsideClick() {
		this.setState({display: false});
	}

	render() {
		const display = (this.state.display) ? 'app__tooltip--display' : '';
		const icon = (this.state.display) ? String.fromCharCode(215) : 'i';
		return (
			<div ref={node => this.node = node} className="app__tooltip">
				<button type="button" aria-label="Toggle Tooltip" className={`app__tooltip-button ${display}`} onClick={this.handleClick}>
					<span aria-hidden="true">{icon}</span>
				</button>
				<span className={`app__tooltip-text ${display}`} role="status" aria-hidden={!this.state.display}>{this.props.content}</span>
			</div>
		)
	}
}

export default ToolTip;



// WEBPACK FOOTER //
// ./src/components/ToolTip.js